import { useAppSelector } from 'appState/store'
import { useUserProfile } from 'features/settings/settingsHooks'
import { IUserRoleGuidEnum } from 'features/settings/settingsTypes'
import { FaBolt } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { useCheckBatchStatus } from '../autoCheckHooks'
import { BatchProcessingStatus, BatchType } from '../types'
import { handelBatchUpgrade } from './formatter'

export const UpgradeBatch = (params: any) => {
  const { user } = useAppSelector((state) => state.auth)
  const { data: batchSettings } = useCheckBatchStatus()

  const batchProcessingSettings = batchSettings?.filter((setting: any) => setting.key === 'batchprocessorenabled')[0]

  const { data: profile } = useUserProfile(user?.id)
  //defigning roles
  const roleIds = profile?.roles.map((role) => role.roleId)
  const isrunAutocheckUser = roleIds?.includes(IUserRoleGuidEnum.runAutoCheckPermission)
  const isClaimImport = params.data.batchType === BatchType.Claim_Import
  const isValidationCompleted = params.data.processingStatus === BatchProcessingStatus.Validation_Completed
  const isPendingForReview = params.data.processingStatus === BatchProcessingStatus.Pending_Approval
  const isValidatingOrPendingForReview = isValidationCompleted || isPendingForReview

  if (batchProcessingSettings?.value === 'true') {
    if (isValidatingOrPendingForReview && isrunAutocheckUser && !isClaimImport) {
      return (
        <Div>
          <ActionButton>
            <Button
              variant="primary"
              size="small"
              radius="normal"
              onClick={() => handelBatchUpgrade(params, params.data.batchType)}
            >
              <FaBolt /> Start
            </Button>
          </ActionButton>
        </Div>
      )
    }
  } else {
    return (
      <Div>
        <ActionButton>
          <Button variant="primary" disabled={true} size="small" radius="normal">
            Batch Processing Disabled
          </Button>
        </ActionButton>
      </Div>
    )
  }
}

const ActionButton = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
`

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamily.milliard};
  font-style: normal;
  .custom-btn-close {
    font-size: 1.375rem !important;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    ${({ theme }) => theme.typography.m.normal};
    line-height: 1.125rem;
    background: none !important;
    border: none;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
`
